import React, { Fragment } from 'react';
import PropTypes from "prop-types";

import {connect} from "react-redux";

import { Link } from 'react-router-dom';

import CatalogDescription
  from 'components/dashboard/catalog-content/CatalogDescription';
import AddCatalogProductForm
  from 'components/dashboard/catalog-content/AddCatalogProductForm';
import CatalogProductsList
  from 'components/dashboard/catalog-content/CatalogProductsList';
import CommonMessage from 'components/common/CommonMessage';

import './CatalogPageContent.css';

const CatalogPageContent = ({ me, catalogProductsList }) => {
  if (!me) return null;

  return (
    <div className="catalog-page-content__component">
      <Fragment>
        <CatalogDescription />
        <AddCatalogProductForm />
        {/*{me &&*/}
        {/*  me.subscription &&*/}
        {/*  me.subscription.billing_plan &&*/}
        {/*  me.subscription.billing_plan.title === 'Starter' &&*/}
        {/*  catalogProductsList &&*/}
        {/*  catalogProductsList.length > 2 ?*/}
        {/*  <CommonMessage warning>*/}
        {/*    You can add more than 3 products on the <strong>PRO</strong> plan.*/}
        {/*    Check it <Link to="billing">here</Link>*/}
        {/*  </CommonMessage>*/}
        {/*  :*/}
        {/*  <AddCatalogProductForm />*/}
        {/*}*/}
        <CatalogProductsList />
      </Fragment>
    </div>
  );
};


CatalogPageContent.propTypes = {
  me: PropTypes.object,
  catalogProductsList: PropTypes.arrayOf(PropTypes.shape),
};

CatalogPageContent.defaultProps = {
  me: null,
  catalogProductsList: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    catalogProductsList: state.catalogReducer.catalogProductsList,
  }
);

export default connect(
  mapStateToProps,
  {},
)(CatalogPageContent);
